import TheMainLayout from "@/layouts/TheMainLayout/TheMainLayout.vue"
import { HEADER_TYPE } from "@/interfaces/header"
import { RouterView } from "vue-router"

const defaults = {
  meta: {
    requiresAuth: true
  }
}

const routes = [
  {
    path: "/",
    name: "home",
    component: TheMainLayout,
    redirect: () => ({ name: "qrs", params: { state: "all" } }),
    children: [
      {
        path: "/qrs/:state(all|active|trash|paused)?/",
        name: "qrs",
        component: () => import("../views/QrsView.vue"),
        meta: defaults.meta
      },
      {
        path: "/project/:state(all|active|trash|paused)?/:uuid",
        name: "project",
        component: () => import("../views/ProjectView.vue"),
        meta: defaults.meta
      },
      {
        path: "/account",
        name: "account",
        component: () => import("../views/AccountView.vue"),
        meta: {
          ...defaults.meta,
          headerType: HEADER_TYPE.ACCOUNT
        }
      },

      {
        path: "/settings",
        name: "settings",
        component: () => import("../views/People&Settings/SettingsView.vue"),
        meta: {
          ...defaults.meta,
          headerType: HEADER_TYPE.SETTINGS
        }
      },
      {
        path: "/billing",
        name: "billing",
        component: () => import("../views/People&Settings/BillingView.vue"),
        meta: {
          ...defaults.meta,
          headerType: HEADER_TYPE.SETTINGS
        }
      },
      {
        path: "/people",
        name: "people",
        component: () => import("../views/People&Settings/PeopleView.vue"),
        meta: {
          ...defaults.meta,
          headerType: HEADER_TYPE.SETTINGS
        }
      },
      {
        path: "/whitelabel",
        name: "whitelabel",
        component: () => import("../views/People&Settings/WhiteLabelView.vue"),
        meta: {
          ...defaults.meta,
          headerType: HEADER_TYPE.SETTINGS
        }
      },
      {
        path: "/single-sign-on",
        name: "single-sign-on",
        component: () => import("../views/People&Settings/SingleSignOnView.vue"),
        meta: {
          ...defaults.meta,
          headerType: HEADER_TYPE.SETTINGS
        }
      },
      {
        path: "/qr-stats/:uuid",
        name: "qr-stats",
        component: () => import("../views/StatsView.vue"),
        meta: {
          ...defaults.meta,
          headerType: HEADER_TYPE.STATS,
          layout: {
            sidebarCollpased: true
          }
        }
      }
    ]
  },
  {
    path: "/qr-builder",
    name: "qr-builder",
    redirect: () => ({ name: "qr-builder-create" }),
    component: RouterView,
    children: [
      {
        path: "/create",
        name: "qr-builder-create",
        component: () => import("../views/QrBuilder/QrBuilderCreateView.vue"),
        meta: defaults.meta
      },
      {
        path: "/settings/:uuid/:step(qr|type|content)",
        name: "qr-builder-settings",
        component: () => import("../views/QrBuilder/QrBuilderView.vue"),
        meta: defaults.meta
      }
    ]
  },
  {
    path: "/checkout/:planUuid",
    name: "checkout",
    component: () => import("../views/Checkout/CheckoutBillingDetailsView.vue"),
    meta: defaults.meta
  }
]

export default routes
